// extracted by mini-css-extract-plugin
module.exports = {"totaliser":"TotalsSection_totaliser__Ccfvd"};